import { getCountryList } from '../s3Config';
import { httpManager as http } from '@/plugins/HttpManager';
import nprogress from 'nprogress';
import { unfoldError } from '../../common/js/notice';
import { config } from 'CONFIG';
import { ESeriesCategory } from '@reolink-cloud/interface';
import { animatedPlanFilter } from '@/utils/business';

export const getCloudProductListsAPI = ( lang, legacy = '' ): any => {

    let qs = `/cloud/products?lang=${lang}&visible_only=false`;
    if ( legacy ) {

        qs += `&legacy_tag=${legacy}`;

    }
    return new Promise(( resolve, reject ) => {

        http.get( qs ).then( res => {

            resolve( res );

        }).catch( error => {

            reject( error );

        });

    });

};
export const getSupportedCountries = ( allCountryList, countriesList, data ): any => {

    const timeStamp = process.env.TIME_STAMP;
    data.supportedCountryList = allCountryList.filter( country => countriesList.includes( country.code )).map(
        country => {

            return {

                code: country.code,
                text: country.name,
                image: `https://home-cdn.reolink.us/wp-content/assets/carrier/${country.name.toLowerCase().split( ' ' ).join( '_' )}.png?sv=${timeStamp!}`

            };

        }

    );

};

// ! 按照ip判定userCountry不需要传参数
// ! 获取全部套餐userCountry传'all'
export const getCloudProductLists = async ( lang = 'en', userCountry = '', legacyOption = { legacy: '', page: '' }, shouldIncludeNotificationPlan = false, includedCategories: ESeriesCategory[] = [ESeriesCategory.CLOUD_STORAGE_PLAN, ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN] ): Promise<any> => {

    nprogress.set( 0.6 );
    let legacy = legacyOption.legacy;
    let allCountryList, res;
    try {

        allCountryList = await getCountryList();
        if ( legacyOption.legacy ) {

            res = await getCloudProductListsAPI( lang, legacy );
            if ( JSON.stringify( res.data.planSeries ) === '{}' && JSON.stringify( res.data.plans ) === '{}' ) {

                res = await getCloudProductListsAPI( lang );
                legacy = '';

            }

        } else {

            res = await getCloudProductListsAPI( lang );

        }

    } catch ( err ) {

        unfoldError( 'errors.server_error', 99999 );
        nprogress.done();
        console.log( err );

    }

    const cloudProductLists = res.data;
    let planSeries = cloudProductLists.planSeries;
    const plans = cloudProductLists.plans;

    const storageLocList = {};
    // 将套餐放到系列下，将系列的style赋予每个套餐让已有组件不需更改逻辑
    Object.keys( plans ).map(( id ) => {

        plans[id].style['plan.display_color'] = planSeries[plans[id].seriesKey].style['series.display_color'];
        plans[id].style['plan.recommended'] = planSeries[plans[id].seriesKey].style['series.recommended'];
        plans[id].title = planSeries[plans[id].seriesKey].i18n.name;
        planSeries[plans[id].seriesKey].plans = typeof planSeries[plans[id].seriesKey].plans === 'undefined' ? [] : planSeries[plans[id].seriesKey].plans;
        planSeries[plans[id].seriesKey].plans.push( plans[id] );

    });

    // 获取机型的详细信息，包括图片，链接，名称
    Object.keys( cloudProductLists.deviceModelGroups ).map( group => {

        const models = cloudProductLists.deviceModelGroups[group].models;
        const modelArr: any[] = [];
        const modelUniArr: any[] = [];
        for ( const model of models ) {

            if ( !modelUniArr.includes( cloudProductLists.deviceModels[model].title )) {

                modelUniArr.push( cloudProductLists.deviceModels[model].title );
                modelArr.push({
                    image: `${typeof cloudProductLists.deviceModels[model].styles.imageUrl !== 'undefined' && cloudProductLists.deviceModels[model].styles.imageUrl !== '' ? cloudProductLists.deviceModels[model].styles.imageUrl : ''}`,
                    link: `${typeof cloudProductLists.deviceModels[model].styles.link !== 'undefined' && cloudProductLists.deviceModels[model].styles.link !== '' ? cloudProductLists.deviceModels[model].styles.link : config.reolink}`,
                    text: cloudProductLists.deviceModels[model].title,
                    visible: cloudProductLists.deviceModels[model].visible,
                    key: cloudProductLists.deviceModels[model].key
                });

            }

        }

        cloudProductLists.deviceModelGroups[group].models = modelArr;
        cloudProductLists.deviceModelGroups[group].modelIds = models;

    });

    if ( !legacy &&
        ( legacyOption.page === 'update-plan' ||
         legacyOption.page === 'subscribe' ||
         legacyOption.page === 'homepage' )) {

        // 过滤legacy plan
        const newPlanSeries = {};
        Object.keys( planSeries ).map( series => {

            if ( !planSeries[series].legacyTag ) {

                newPlanSeries[series] = planSeries[series];

            }

        });
        planSeries = newPlanSeries;

    }

    // 处理每个系列的可用国家
    Object.keys( planSeries ).map( series => {

        const countryGroupNames = planSeries[series].countryGroups;
        let planSeriesCountries = [];
        for ( const countryGroupName of countryGroupNames ) {

            if ( typeof cloudProductLists.countryGroups[countryGroupName] !== 'undefined' ) {

                for ( const country of cloudProductLists.countryGroups[countryGroupName].countries ) {

                    planSeriesCountries = planSeriesCountries.concat( country.key );

                }

            }
            getSupportedCountries( allCountryList, planSeriesCountries, planSeries[series] );

        }

    });

    let searchCountry;
    if ( userCountry !== '' && userCountry !== 'all' ) {

        searchCountry = userCountry;

    }
    else {

        searchCountry = cloudProductLists.country;

    }
    // 将套餐系列按存储地进行分类
    Object.keys( cloudProductLists.storageRegions ).map(( region ) => {

        const deviceGroupsListAll = {};
        const _region = {};

        Object.keys( planSeries ).map(( key ) => {

            const category = planSeries[key].category;
            /** 过滤流量套餐 */
            if ( !includedCategories.includes( category ) || ( category === ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN && !shouldIncludeNotificationPlan )) {

                return;

            }
            deviceGroupsListAll[planSeries[key].deviceGroup] = typeof deviceGroupsListAll[planSeries[key].deviceGroup] === 'undefined' ? {} : deviceGroupsListAll[planSeries[key].deviceGroup];
            deviceGroupsListAll[planSeries[key].deviceGroup].planList = typeof deviceGroupsListAll[planSeries[key].deviceGroup].planList === 'undefined' ? [] : deviceGroupsListAll[planSeries[key].deviceGroup].planList;
            deviceGroupsListAll[planSeries[key].deviceGroup].key = planSeries[key].deviceGroup;
            if ( planSeries[key].storageRegion === region ) {

                const products = ( planSeries[key].plans ?? [] ).filter( plan => shouldIncludeNotificationPlan ? plan.style['cloud_storage.allow_rich_notification'] : true ).filter( animatedPlanFilter ).sort(( a, b ) => a.style['plan.sort'] - b.style['plan.sort'] );
                if ( key.includes( 'basic' )) {

                    // 如果存在多个basic套餐，这里会取最后一个
                    if ( products.length > 0 ) {

                        deviceGroupsListAll[planSeries[key].deviceGroup].basicSerial = planSeries[key];

                    }

                } else {

                    if ( products.length > 0 ) {

                        deviceGroupsListAll[planSeries[key].deviceGroup].planList.push({ products, serialName: key, sortOrder: planSeries[key].style['series.sort'] });

                    }

                }

            }

            _region['planSeries'] = typeof _region['planSeries'] === 'undefined' ? {} : _region['planSeries'];
            if ( planSeries[key].storageRegion === region ) {

                _region['planSeries'][key] = planSeries[key];

            }

        });
        if ( JSON.stringify( _region['planSeries'] ) !== '{}' ) {

            storageLocList[region] = _region;
            storageLocList[region].deviceGroupsList = deviceGroupsListAll;

        }

    });
    // 获取每个存储地的可用国家,区分基础套餐与高级套餐
    // 获取每个存储地的deviceGroup
    let defaultStorageRegion: Record<string, any> = {};
    let cloudModels: any[] = [];
    Object.keys( storageLocList ).map(( loc ) => {

        let countriesGroupsList: any[] = [];
        let countriesList: any[] = [];
        const deviceGroupsIdList: any[] = [];
        const storageDeviceGroupsList = storageLocList[loc].deviceGroupsList;

        Object.keys( storageLocList[loc]['planSeries'] ).map(( key ) => {

            // 对国家信息进行处理
            const countryGroupName = storageLocList[loc]['planSeries'][key].countryGroups;
            countriesGroupsList = countriesGroupsList.concat( countryGroupName );

            // 对机型组信息进行处理
            const deviceGroupName = storageLocList[loc]['planSeries'][key].deviceGroup;
            if ( typeof cloudProductLists.deviceModelGroups[deviceGroupName] !== 'undefined' ) {

                if ( !deviceGroupsIdList.includes( cloudProductLists.deviceModelGroups[deviceGroupName].id )) {

                    deviceGroupsIdList.push( cloudProductLists.deviceModelGroups[deviceGroupName].id );
                    storageDeviceGroupsList[deviceGroupName].id = cloudProductLists.deviceModelGroups[deviceGroupName].id;
                    storageDeviceGroupsList[deviceGroupName].title = cloudProductLists.deviceModelGroups[deviceGroupName].i18n.name;
                    storageDeviceGroupsList[deviceGroupName].des = cloudProductLists.deviceModelGroups[deviceGroupName].i18n.description;
                    storageDeviceGroupsList[deviceGroupName].models = cloudProductLists.deviceModelGroups[deviceGroupName].models;
                    const models = cloudProductLists.deviceModelGroups[deviceGroupName].models.map( item => item.text );
                    cloudModels = [...cloudModels, ...models];
                    storageDeviceGroupsList[deviceGroupName].sort = cloudProductLists.deviceModelGroups[deviceGroupName].metadata?.sort ?? 0;
                
                }

            }

        });
        countriesGroupsList = Array.from( new Set( countriesGroupsList ));

        for ( const countryGroup of countriesGroupsList ) {

            if ( typeof cloudProductLists.countryGroups[countryGroup] !== 'undefined' ) {

                for ( const country of cloudProductLists.countryGroups[countryGroup].countries ) {

                    countriesList = countriesList.concat( country.key );

                }

            }

        }
        countriesList = Array.from( new Set( countriesList ));
        getSupportedCountries( allCountryList, countriesList, storageLocList[loc] );

        if ( countriesList.includes( searchCountry )) {

            defaultStorageRegion = JSON.stringify( defaultStorageRegion ) === '{}' ? {
                i18n: cloudProductLists.storageRegions[loc].i18n,
                key: cloudProductLists.storageRegions[loc].key,
                loc: loc,
                sortOrder: cloudProductLists.storageRegions[loc].sortOrder,
            } : defaultStorageRegion;

            if ( cloudProductLists.storageRegions[loc].sortOrder < defaultStorageRegion.sortOrder ) {

                defaultStorageRegion = {
                    i18n: cloudProductLists.storageRegions[loc].i18n,
                    key: cloudProductLists.storageRegions[loc].key,
                    loc: loc,
                    sortOrder: cloudProductLists.storageRegions[loc].sortOrder,
                };

            }

        }

    });
    cloudProductLists.defaultStorageRegion = defaultStorageRegion;
    cloudProductLists.cloudModels = Array.from( new Set( cloudModels ));

    return { cloudProductLists, storageLocList: storageLocList, country: res.data.country };

};

//根据用户国家查询对应的默认存储地
export function getStorageRegionByCountry(
    cloudProductLists: any,
    storageLocList: any,
    userCountry: string = ''
) {

    const searchCountry =
        userCountry && userCountry !== 'all'
            ? userCountry
            : config.fallbackCountry;

    let hit: Record<string, any> = {};
    const isEmpty = ( o: Record<string, any> ) => Object.keys( o ).length === 0;

    for ( const regionKey of Object.keys( cloudProductLists.storageRegions )) {

        const region = cloudProductLists.storageRegions[regionKey];
        const countriesInRegion: string[] = [];

        for ( const seriesKey of Object.keys( cloudProductLists.planSeries )) {

            const series = cloudProductLists.planSeries[seriesKey];
            if ( series.storageRegion !== regionKey ) continue;

            for ( const countryGroupsName of series.countryGroups ) {

                const countryGroups = cloudProductLists.countryGroups[countryGroupsName];
                if ( !countryGroups ) continue;

                for ( const country of countryGroups.countries ) {

                    countriesInRegion.push( country.key );

                }

            }

        }

        const uniqueCountries = Array.from( new Set( countriesInRegion ));
        if ( uniqueCountries.includes( searchCountry )) {

            if (( isEmpty( hit ) || region.sortOrder < hit.sortOrder ) && regionKey in storageLocList ) {

                hit = {
                    i18n: region.i18n,
                    key: region.key,
                    loc: regionKey,
                    sortOrder: region.sortOrder,
                };

            }

        }

    }

    cloudProductLists.defaultStorageRegion = hit;

    return cloudProductLists;

}
